import { onMounted, ref } from "vue";

export interface CaptchaType {
    /** 刷新验证码 */
    refresh: () => void;
    /** 显示验证码 */
    show: () => void;
    /** 隐藏验证码 */
    hide: () => void;
    /** 销毁验证码 */
    destroyCaptcha: () => void;
}

/** 阿里云验证码hook */
export const useCaptcha = (opt: {
    /** 验证成功后的回调 */
    captchaVerifyCallback: (captchaVerifyParam: string) => void;
}) => {
    /** 阿里云验证码实例 */
    const captcha = ref<CaptchaType>();

    const getInstance = (instance: CaptchaType) => {
        captcha.value = instance;
    };

    const onBizResultCallback = (bizResult: boolean) => {
        console.log("onBizResultCallback", bizResult);
    };
    onMounted(() => {
        try {
            window.initAliyunCaptcha({
                SceneId: "1wjppc2z",
                prefix: "16z09e",
                mode: "embed",
                element: "#captcha-element",
                button: "#captcha-button",
                captchaVerifyCallback: opt.captchaVerifyCallback,
                onBizResultCallback,
                getInstance,
                slideStyle: { width: 320, height: 40 },
                language: "cn",
                immediate: true
            });
        } catch (error) {
            console.error("阿里云验证码初始化失败", error);
        }
    });

    return captcha;
};
